/**
 * @generated SignedSource<<bb56a5c597f0d62816051d3a7e040d6b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BudgetSideEnum = "COST" | "REVENUE" | "%future added value";
export type budgetsPage_Query$variables = Record<PropertyKey, never>;
export type budgetsPage_Query$data = {
  readonly budgets: ReadonlyArray<{
    readonly basis: string | null | undefined;
    readonly entryCount: number;
    readonly id: string;
    readonly name: string;
    readonly perspective: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly side: BudgetSideEnum;
    readonly totalCents: number;
    readonly updatedAt: any;
    readonly year: number;
  }>;
};
export type budgetsPage_Query = {
  response: budgetsPage_Query$data;
  variables: budgetsPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Budget",
    "kind": "LinkedField",
    "name": "budgets",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "side",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "year",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "basis",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "entryCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCents",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Perspective",
        "kind": "LinkedField",
        "name": "perspective",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "budgetsPage_Query",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "budgetsPage_Query",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "5f7164a82850ac69eadfe71c72cb0ffc",
    "id": null,
    "metadata": {},
    "name": "budgetsPage_Query",
    "operationKind": "query",
    "text": "query budgetsPage_Query {\n  budgets {\n    id\n    name\n    side\n    year\n    basis\n    entryCount\n    totalCents\n    updatedAt\n    perspective {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6c187f90451ca1442869bc1e34f27c5f";

export default node;
